import React from "react";
import { useTranslation } from "react-i18next";

import { INotification } from "../../../models";
import { MonthNumber } from "../../../constants/MonthNumber";

interface INotificationsTimesheetStatusProps {
  itemData: INotification;
}

export const NotificationsTimesheetStatus: React.FC<INotificationsTimesheetStatusProps> = ({
  itemData,
}) => {
  const t: any = (useTranslation() as any).t;

  const monthIndex = Number(`${itemData.timesheet.date[3]}${itemData.timesheet.date[4]}`);
  const timesheetMonth = MonthNumber()[monthIndex];
  const monthKey = String(timesheetMonth?.translate_code ?? "");

  const statusText: Record<string, string> = {
    reject: String(t("timesheet_page.notifications.your_timesheet_rejected"))
      .replace("[month]", String(t(monthKey)))
      .replace("[місяць]", String(t(monthKey))),

    approve: String(t("timesheet_page.notifications.your_timesheet_approved"))
      .replace("[month]", String(t(monthKey)))
      .replace("[місяць]", String(t(monthKey))),
  };

  const statusIcon: Record<string, string> = {
    reject: "#round-error",
    approve: "#round-check",
  };

  const statusIconClass: Record<string, string> = {
    approve: "is-success",
    reject: "is-danger",
  };

  return (
    <div className="notification__item">
      <div className={`notification__block--icon ${statusIconClass[itemData.type]}`}>
        <svg width="20" height="20" viewBox="0 0 20 20">
          <use xlinkHref={statusIcon[itemData.type]} />
        </svg>
      </div>

      <div className="notification__block--text">
        <p>{statusText[itemData.type]}</p>
      </div>
    </div>
  );
};


